var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91669 20.9987L0.416687 11.4987L2.79169 9.1237L9.91669 16.2487L25.2084 0.957031L27.5834 3.33203L9.91669 20.9987Z",
    fill: "#273848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightSign);
export default __webpack_public_path__ + "static/media/RightSign.13809d351527a1e8f56c8d0afe026b0b.svg";
export { ForwardRef as ReactComponent };